"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Pagination_1 = require("./Pagination");
exports.default = Pagination_1.Pagination;
